import React from "react";
import { Modal, Box, Button, Typography } from "@mui/material";

export default function SolicitarReview({
  open,
  onClose,
  telefono,
  nombre,
  onSolicitar,
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 420,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{ mb: 2, fontWeight: 600 }}
        >
          ¿Solicitar reseña al cliente?
        </Typography>

        <Typography sx={{ mb: 1 }}>
          <strong>Cliente:</strong> {nombre}
        </Typography>

        <Typography sx={{ mb: 3 }}>
          <strong>Teléfono:</strong> {telefono}
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
          >
            No
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={onSolicitar}
          >
            Sí, solicitar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}